<mat-checkbox class="mb-4 whitespace-pre-wrap"
              *ngFor="let aParam of extProfilesService.getParams(keyname)"
              [formControl]="fGroup.get(aParam.key)">
  <span *ngIf="displayDebug">{{ aParam.key }} -> </span>

  <ng-container *ngIf="!isMobile">
    <img *ngIf="aParam.media?.url"
         src="{{aParam.media.url}}"
         alt="image" [style.width]="aParam.media.zoomSelectedImg + 'px'"
         class="image-label">
    <span class="w-full">{{ aParam.label[curLang] }}</span>
  </ng-container>

  <ng-container *ngIf="isMobile">
    <div>
      <img *ngIf="aParam.media?.url"
           src="{{aParam.media.url}}"
           alt="image" [style.width]="aParam.media.zoomSelectedImg + 'px'"
           class="image-label">
    </div>
    <div class="w-full">{{ aParam.label[curLang] }}</div>
    </ng-container>
</mat-checkbox>

<mat-error *ngIf="fGroup.hasError('atLeastOne')">
  {{ 'Ce champ est obligatoire'|transloco }}
</mat-error>


